import React, { Fragment, useState, useEffect } from "react";
import {
  PaymentContainer,
  HyperLink,
  TopCenter,
} from "../../PaymentHistory/Styles";
import { TableWrapper } from "../index";
import _ from "lodash";
import queryString from "query-string";
import CustomTable from "./CustomTable";
import CaseService from "../../../../services/CaseService";
import moment from "moment";
import {
  getErrorMessage,
  getFileFormat,
  getFileName,
} from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import labels from "../../../../helpers/labels.json";
import {
  ButtonWrapper,
  AcceptButton,
  DeclineButton,
  Footer,
  ButtonContainer,
  DangerBtn,
  StatusBadge,
} from "../Styles";
import useLoader from "../../../../hooks/useLoader";
import Preview from "./Preview";
import { PrimaryCTAButton } from "../../../common/Buttons";
import AlertDialog from "./AlertWrapper";
import theme from "../../../../assets/theme";
import { CommentSplitUp } from "./CommentSplitUp";
import useNotification from "../../../../hooks/useNotification";

async function getMakerCheckerDetails(query = "") {
  try {
    const response = await CaseService.getMakerCheckerDetails(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

// const initFilters = [
//   { label: "All", value: 0 },
//   { label: "Pending", value: 0 },
//   { label: "Approved", value: 0 },
//   { label: "Rejected", value: 0 },
// ];

const filterByStatus = (selectedFilter) => {
  switch (selectedFilter) {
    case "Pending":
      return "notChecked";
    case "Approved":
      return "checked";
    case "Rejected":
      return "rejected";
    default:
      return ""; // All
  }
};

const UploadAudit = ({ auditor, id, MTRef }) => {
  const [state, setState] = useState({});
  // const [filters, setFilters] = useState(initFilters);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const placeholderText = "Search upload";
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [modal, setModal] = useState({ state: false });
  const [selectedId, setSelectedId] = useState([]);
  const { triggerNotify, setTriggerNotify } = useNotification();

  // function setStats(total) {
  //   const checkStatusFilter = filterByStatus(selectedFilter);
  //   setFilters([
  //     { label: "All", value: checkStatusFilter === "" ? total ?? 0 : 0 },
  //     { label: "Pending", value: checkStatusFilter === "notChecked" ? total ?? 0 : 0 },
  //     { label: "Approved", value: checkStatusFilter === "checked" ? total ?? 0 : 0 },
  //     { label: "Rejected", value: checkStatusFilter === "rejected" ? total ?? 0 : 0 },
  //   ]);
  // }
  const [dialogData, setDialogData] = useState({});
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedFilter && MTRef?.current?.onQueryChange) {
      MTRef.current.onQueryChange({
        ...MTRef.current.state.query,
        page: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilter]);

  async function makerChekerUpdateStatus(
    reasonText,
    checkerId,
    id,
    status,
    ownerType,
    ownerId,
  ) {
    try {
      setLoader({ state: true, message: `split and upload...` });
      const payload = {
        id: [id],
        checkStatus: status,
        checkerId: parseInt(checkerId),
        filter: "bulkDocumentUploader",
        comments: reasonText,
        entityType: ownerType,
        entityId: ownerId,
      };
      const response = await CaseService.updateMakerChekerStatus(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  const columns = [
    {
      field: "id",
      title: "Id",
      sorting: false,
      render: (rowData) => <TopCenter>{rowData?.id}</TopCenter>,
      cellStyle: {
        width: 80,
      },
    },
    {
      field: "name",
      title: "Maker Name",
      sorting: false,
      render: (rowData) => rowData?.makerDetails?.name,
    },
    {
      field: "name",
      title: "Checker Name",
      sorting: false,
      render: (rowData) =>
        rowData?.checkerDetails?.name ? rowData?.checkerDetails?.name : "-",
    },
    {
      field: "updated_at",
      title: labels["table.date"],
      sorting: false,
      render: (rowData) => (
        <>
          {moment(rowData?.updated_at, "YYYY-MM-DD HH:mm:ss")
            .add(5, "hours")
            .add(30, "minutes")
            .format("DD MMM YYYY, hh:mm A")}
        </>
      ),
      headerStyle: {
        width: 220,
      },
      cellStyle: {
        width: 230,
      },
    },
    {
      field: "id",
      title: "Preview",
      sorting: false,
      render: (rowData) => (
        <HyperLink
          style={{
                width: "auto",
                maxWidth: "100%",
                textDecoration: "underline",
                cursor: "pointer",
                whiteSpace: "normal",
                textOverflow: "ellipsis",
                overflow: "anywhere",
          }}
          onClick={() =>
            setModal({
              state: true,
              url: rowData?.url,
              format: getFileFormat(rowData?.url),
              pdf: rowData?.url.toLowerCase().endsWith(".pdf"),
            })
          }
        >
          {getFileName(rowData?.url)}
        </HyperLink>
      ),
    },
    {
      field: "checkStatus",
      title: "Status",
      sorting: false,
      render: (rowData) =>
        rowData?.checkStatus === "checked" ? (
          <StatusBadge status="Approved">Approved</StatusBadge>
        ) : rowData?.checkStatus === "rejected" ? (
          <StatusBadge status="Rejected">Rejected</StatusBadge>
        ) : (
          <StatusBadge status="Pending">Pending</StatusBadge>
        ),
    },
    {
      field: "actions",
      title: "Actions",
      sorting: false,
      hidden: auditor === "maker" ? true : false,
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) =>
        rowData?.checkerAcceptedAt ? (
          <ButtonWrapper>
            <TopCenter>Completed</TopCenter>
          </ButtonWrapper>
        ) : (
          <ButtonWrapper>
            <AcceptButton
              onClick={() =>
                makerChekerUpdateStatus(
                  "",
                  rowData?.checkerId,
                  rowData?.id,
                  "checked",
                  rowData?.ownerType,
                  rowData?.ownerId,
                )
              }
            >
              <img
                src={require("../../../../assets/images/checkBoxSelected.svg")}
                alt="accept"
              />
            </AcceptButton>
            <DeclineButton
              onClick={() => {
                setOpen(true);
                setDialogData({
                  primaryBtnText: "Cancel",
                  secondaryBtnText: "Submit",
                  clickSecondarybtn: (reasonText) =>
                    makerChekerUpdateStatus(
                      reasonText,
                      rowData?.checkerId,
                      rowData?.id,
                      "rejected",
                      rowData?.ownerType,
                      rowData?.ownerId,
                    ),
                  clickPrimaryBtn: () => setOpen(false),
                  onDialogClose: () => setOpen(false),
                  desc: `Please note once you reject the upload, you cannot continue approve again.`,
                  heading: "Do you really want to Reject this upload?",
                  status: true,
                  descriptionTextStyle: {
                    textAlign: "left",
                    fontFamily: theme.fonts.primaryFontSemiBold,
                  },
                });
              }}
            >
              <img
                src={require("../../../../assets/images/closeButton.svg")}
                alt="decline"
              />
            </DeclineButton>
          </ButtonWrapper>
        ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
         params.search = query.search;
         params.partyName = query.search;
     }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      const checkStatusFilter = filterByStatus(selectedFilter);
      if (checkStatusFilter) {
        params.checkStatus = checkStatusFilter;
      }
      let stringParams = "";

      if (!_.isEmpty(params)) {
        stringParams = `/${auditor}/${id}/bulkDocumentUploader?${queryString.stringify(
          params,
        )}`;
      }
      getMakerCheckerDetails(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
            // setStats(result.total);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

     useEffect(() => {
          if (triggerNotify) {
            if (auditor === "maker") {
              MTRef.current.onSearchChange("");
            } else {
              MTRef.current.onQueryChange(MTRef?.current?.state?.query);
            }
            setTriggerNotify(false);
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [triggerNotify]);

  async function handleCaseSelection(reasonText, status) {
    try {
      setLoader({ state: true, message: `split and upload...` });
      const payload = {
        id: selectedId,
        checkStatus: status,
        checkerId: parseInt(id),
        filter: "bulkDocumentUploader",
        comments: reasonText,
      };
      const response = await CaseService.updateMakerChekerStatus(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setSelectedId([]);
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  const detailPanel = [
    {
      tooltip: "View detailed split up...",
      render: (rowData) => {
        return <CommentSplitUp data={rowData} />;
      },
    },
  ];

  return (
    <Fragment>
      <PaymentContainer className="CreateCase" style={{ overflow: "hidden" }}>
        <TableWrapper style={{ marginTop: 20 }}>
          <CustomTable
            selection={auditor === "maker" ? false : true}
            onSelectionChange={(selected) =>
              setSelectedId(
                selected
                  .filter(({ checkerAcceptedAt }) => !checkerAcceptedAt)
                  .map(({ id }) => id),
              )
            }
            hidePagination={state.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            pluralTitle={"Upload"}
            singularTitle=""
            hideFilterBar={auditor === "maker"}
            {...{
              columns,
              data,
              placeholderText,
              MTRef,
              // filters,
              selectedFilter,
              setSelectedFilter,
            }}
            detailPanel={auditor === "maker" ? detailPanel : ""}
            //noToolbar
            state={state}
          />
          {selectedId?.length ? (
            <Footer>
              <ButtonContainer>
                <div className="button-row">
                  <DangerBtn
                    style={{
                      width: "216px",
                      marginLeft: "26px",
                      marginTop: 20,
                    }}
                    onClick={() => {
                      setOpen(true);
                      setDialogData({
                        primaryBtnText: "Cancel",
                        secondaryBtnText: "Submit",
                        clickSecondarybtn: (reasonText) =>
                          handleCaseSelection(reasonText, "rejected"),
                        clickPrimaryBtn: () => setOpen(false),
                        onDialogClose: () => setOpen(false),
                        desc: `Please note once you reject the upload, you cannot continue approve again.`,
                        heading: "Do you really want to reject this upload?",
                        status: true,
                        descriptionTextStyle: {
                          textAlign: "left",
                          fontFamily: theme.fonts.primaryFontSemiBold,
                        },
                      });
                    }}
                  >
                    Reject
                  </DangerBtn>

                  <PrimaryCTAButton
                    style={{
                      width: "216px",
                      marginLeft: "26px",
                      marginTop: 20,
                    }}
                    onClick={() => handleCaseSelection("", "checked")}
                  >
                    Approve
                  </PrimaryCTAButton>
                </div>
              </ButtonContainer>
            </Footer>
          ) : null}
        </TableWrapper>
      </PaymentContainer>
      {modal?.state && <Preview {...{ modal, setModal }} />}
      <AlertDialog
        isOpen={open}
        {...{ ...dialogData }}
        descriptionTextStyle={{
          textAlign: "left",
          fontFamily: theme.fonts.primaryFontSemiBold,
        }}
      />
    </Fragment>
  );
};

export default UploadAudit;
